export const Card = ({ imgURL,label }) => (
  <div className={`flex-view  flex-col max-lg:flex-row  sm:w-[150px] sm:min-w-[150px] max-lg:w-[150px] hover:cursor-pointer shadow-3xl rounded-3xl p-5 }`}>
    {imgURL && <div className="p-2 max-lg:hidden">{imgURL}</div>}
    <h3 className="font-lexendgiga text-xs leading-normal text-pitch-black text-center pt-3 max-lg:pb-3 ">
      {label}
    </h3>
  </div>
);
